module.exports = __webpack_public_path__ + "static/media/Гидравлический пресс.0b2ebbf1.png";